module.exports = __webpack_public_path__ + "static/media/vetsfirst.e57908fa.png";